declare const API_URL: string;
declare const BASE_URL: string;
declare const CLIENT_NAME: string;
declare const IMAGE_BASE_URL: string;
declare const CUSTOM_REFERRER: string;
declare const DEFAULT_LANG: string;
declare const MODE: 'CLIENT' | 'SUPER_ADMIN' | 'ADMIN';
export default {
    Mode: MODE || 'CLIENT',
    ApiUrl: API_URL,
    BaseUrl: BASE_URL,
    DefaultLang: DEFAULT_LANG,
    CustomReferrer: CUSTOM_REFERRER,
    ClientName: CLIENT_NAME,
    ImageBaseUrl: IMAGE_BASE_URL,
};
